module.exports = __webpack_public_path__ + "static/media/final-settings.4e6be583.png";